// extracted by mini-css-extract-plugin
export default {"rightTextClassWrapper":"ReportStyles_rightTextClassWrapper__tnAWo"};